'use client';

import * as React from 'react';
import { useStore } from '@base-ui/utils/store';
import { schedulerEventSelectors } from '@mui/x-scheduler-internals/scheduler-selectors';
import { useEventCalendarStoreContext } from '@mui/x-scheduler-internals/use-event-calendar-store-context';
export function useTimeGridEvent(occurrence) {
  const store = useEventCalendarStoreContext();
  const isRecurring = useStore(store, schedulerEventSelectors.isRecurring, occurrence.id);
  const isDraggable = useStore(store, schedulerEventSelectors.isDraggable, occurrence.id);
  const isStartResizable = useStore(store, schedulerEventSelectors.isResizable, occurrence.id, 'start');
  const isEndResizable = useStore(store, schedulerEventSelectors.isResizable, occurrence.id, 'end');
  const palette = useStore(store, schedulerEventSelectors.color, occurrence.id);
  const durationMs = occurrence.displayTimezone.end.timestamp - occurrence.displayTimezone.start.timestamp;
  const durationMinutes = durationMs / 60000;
  const isBetween30and60Minutes = durationMinutes >= 30 && durationMinutes < 60;
  const isLessThan30Minutes = durationMinutes < 30;
  const isLessThan15Minutes = durationMinutes <= 15;
  const rootDataAttributes = React.useMemo(() => ({
    'data-under-hour': isLessThan30Minutes || isBetween30and60Minutes || undefined,
    'data-under-fifteen-minutes': isLessThan15Minutes || undefined,
    'data-recurrent': isRecurring || undefined,
    'data-palette': palette
  }), [isLessThan30Minutes, isBetween30and60Minutes, isLessThan15Minutes, isRecurring, palette]);
  const rootPositionProps = React.useMemo(() => ({
    start: occurrence.displayTimezone.start,
    end: occurrence.displayTimezone.end,
    style: {
      '--first-index': occurrence.position.firstIndex,
      '--last-index': occurrence.position.lastIndex
    }
  }), [occurrence.displayTimezone.start, occurrence.displayTimezone.end, occurrence.position.firstIndex, occurrence.position.lastIndex]);
  return {
    isRecurring,
    isDraggable,
    isStartResizable,
    isEndResizable,
    palette,
    isLessThan15Minutes,
    isLessThan30Minutes,
    isBetween30and60Minutes,
    rootDataAttributes,
    rootPositionProps
  };
}